import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="screen">
      <div className="results">
        <h1 className="scorebox__k">Página no encontrada</h1>
        <p className="status">Lo que buscas no existe o ha caducado.</p>
        <Link className="cta" to="/">
          Ir al juego
        </Link>
      </div>
    </section>
  );
}
